import { styled } from 'styled-components'

import { Typography } from '../Typography'

export const StyledLink = styled(Typography).attrs({ as: 'a' })`
  color: ${({ theme }) => theme.colors['N Content/Secondary']};
  text-decoration: underline;
  transition: color 0.3s;

  @media (hover: hover) and (pointer: fine) {
    &:focus-visible,
    &:hover {
      color: ${({ theme }) => theme.colors['N Content/Secondary']};
    }
  }

  &:visited {
    color: ${({ theme }) => theme.colors['N Content/Secondary']};
  }
`
